import warning from 'utils/logger';
import { DefaultFindFnParams, ExcelFields, ExcelTemplate } from 'components/registry/types/api';
import { baseApi } from 'api/base';
import { fileApi } from 'api/file';

const downloadExcel = () =>
  baseApi
    .get('/report/excel/list.xls', { responseType: 'blob' })
    .then(fileApi.downloadFile)
    .catch(warning);

const getExcel = (data: DefaultFindFnParams & { groupByField?: ExcelFields }) =>
  baseApi.post('/report/excel/list.xls', data).then(downloadExcel).catch(warning);

const getTemplate = async (entryType: string, productType: string): Promise<ExcelTemplate[]> => {
  const res = await baseApi.get(`/ert/${productType}/${entryType}/templates`);
  return res.data;
};

const saveTemplate = async (
  entryType: string,
  productType: string,
  data: ExcelTemplate
): Promise<ExcelTemplate> => {
  const res = await baseApi.post(`/ert/${productType}/${entryType}/save`, data);
  return res.data;
};

const setDefaultTemplate = async (entryType: string, productType: string, tmplId: string) => {
  await baseApi.get(`/ert/${productType}/${entryType}/${tmplId}/setDefault`);
};

const deleteTemplate = async (id: string) => {
  await baseApi.delete(`/ert/${id}/delete`);
};

export const exportExcelApi = {
  downloadExcel,
  getExcel,
  getTemplate,
  saveTemplate,
  setDefaultTemplate,
  deleteTemplate,
};
